import Repository from './Repository'

export default {
  getListPage(filter, page, queryFilters = '') {
    return Repository.private().get(`/dashboard/${filter}?page=${page}&page_size=50${queryFilters}`)
  },
  getListPagePrograms(filter, page, queryFilters = '') {
    return Repository.private().get(`/dashboard/${filter}?page=${page}&page_size=50${queryFilters}`)
  },
  search(query) {
  	return Repository.private().get(`/quotation/search?q=${query}`)
  },
  reasing(quotation_id, body) {
    return Repository.private().put(`/quotation/${quotation_id}/owner`, body);
  },
  additionalManagement(quotation_id, body) {
    return Repository.private().put(`/quotation/${quotation_id}/additional-management`, body);
  } 
}
